var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDetails = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 23 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Partnergram-Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.04.4_Location---General-/-Address",
    transform: "translate(-129.000000, -65.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subnavigation-/-Events-/-1st",
    transform: "translate(0.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(129.666667, 9.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3.6961582e-13,
    y1: 17.516736,
    x2: 12.1875,
    y2: 17.5,
    id: "Stroke-5-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.72202269e-13,
    y1: 14.516736,
    x2: 18,
    y2: 14.483264,
    id: "Stroke-5-Copy-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.79093149e-13,
    y1: 20.516736,
    x2: 14.1666667,
    y2: 20.5,
    id: "Stroke-5-Copy-3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 20.5,
    height: 10.5
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDetails, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/details.18847957.svg";
export { ForwardRef as ReactComponent };